import 'react';
import classnames from 'classnames';
import styled from 'styled-components';
import { iconClassName, CalloutIcon, ErrorIcon, InfoIcon, SuccessIcon, WarningIcon } from '@thisisbud/bui-react-icons';
import { jsx } from 'react/jsx-runtime';
import { selectFromTheme } from '@thisisbud/sc-utils';

let _$5 = t => t,
  _t$5;
const notificationIconClassName = 'bui-notification-icon';

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledNotificationIcon$5 = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledNotificationIcon",
  componentId: "sc-1wncha-0"
})(_t$5 || (_t$5 = _$5`
  display: inline-block;
  font-size: ${0};
  vertical-align: middle;

  .${0} {
    display: block;
  }
`), "1.166875em", iconClassName);

/**
 * Renders the container of a notification icon.
 *
 * @remarks This component is for internal use only
 * @param props - The component props
 */
function NotificationIcon(props) {
  const {
    children,
    className,
    id
  } = props;
  return /*#__PURE__*/jsx(StyledNotificationIcon$5, {
    className: classnames(notificationIconClassName, className),
    id: id,
    children: children
  });
}
NotificationIcon.displayName = 'NotificationIcon';

let _$4 = t => t,
  _t$4;
const calloutNotificationIconClassName = 'bui-callout-notification-icon';

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledNotificationIcon$4 = /*#__PURE__*/styled(NotificationIcon).withConfig({
  displayName: "StyledNotificationIcon",
  componentId: "sc-u0tdtq-0"
})(_t$4 || (_t$4 = _$4`
  color: ${0};
`), selectFromTheme('colorNotificationInfo'));

/**
 * A component that displays an information notification icon.
 * The component also offers an optional invisible label for screen readers.
 *
 * @param props - The component props
 * @public
 *
 * @example
 * ```javascript
 * import * as React from 'react'
 * import { InfoNotificationIcon } from '@thisisbud/bui-react-notification-icons'
 *
 * function Example() {
 *   return <InfoNotificationIcon label='Action required'/>
 * }
 * ```
 */
function CalloutNotificationIcon(props) {
  const {
    className,
    id,
    label
  } = props;
  return /*#__PURE__*/jsx(StyledNotificationIcon$4, {
    className: classnames(calloutNotificationIconClassName, className),
    id: id,
    children: /*#__PURE__*/jsx(CalloutIcon, {
      label: label
    })
  });
}
CalloutNotificationIcon.displayName = 'CalloutNotificationIcon';

// Info
const colorInfoIcon = '#0e8fec';

// Warning
const colorWarningIcon = '#fda700';

// Success
const colorPositiveIcon = '#27aa53';

// Error
const colorNegativeIcon = '#f62106';

let _$3 = t => t,
  _t$3;
const errorNotificationIconClassName = 'bui-error-notification-icon';

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledNotificationIcon$3 = /*#__PURE__*/styled(NotificationIcon).withConfig({
  displayName: "StyledNotificationIcon",
  componentId: "sc-16jygtm-0"
})(_t$3 || (_t$3 = _$3`
  color: ${0};
`), colorNegativeIcon);

/**
 * A component that displays an error notification icon.
 * The component also offers an optional invisible label for screen readers.
 *
 * @param props - The component props
 * @public
 *
 * @example
 * ```javascript
 * import * as React from 'react'
 * import { ErrorNotificationIcon } from '@thisisbud/bui-react-notification-icons'
 *
 * function Example() {
 *   return <ErrorNotificationIcon label='Error'/>
 * }
 * ```
 */
function ErrorNotificationIcon(props) {
  const {
    className,
    id,
    label
  } = props;
  return /*#__PURE__*/jsx(StyledNotificationIcon$3, {
    className: classnames(errorNotificationIconClassName, className),
    id: id,
    children: /*#__PURE__*/jsx(ErrorIcon, {
      label: label
    })
  });
}
ErrorNotificationIcon.displayName = 'ErrorNotificationIcon';

let _$2 = t => t,
  _t$2;
const infoNotificationIconClassName = 'bui-info-notification-icon';

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledNotificationIcon$2 = /*#__PURE__*/styled(NotificationIcon).withConfig({
  displayName: "StyledNotificationIcon",
  componentId: "sc-7e0vxu-0"
})(_t$2 || (_t$2 = _$2`
  color: ${0};
`), colorInfoIcon);

/**
 * A component that displays an information notification icon.
 * The component also offers an optional invisible label for screen readers.
 *
 * @param props - The component props
 * @public
 *
 * @example
 * ```javascript
 * import * as React from 'react'
 * import { InfoNotificationIcon } from '@thisisbud/bui-react-notification-icons'
 *
 * function Example() {
 *   return <InfoNotificationIcon label='Note'/>
 * }
 * ```
 */
function InfoNotificationIcon(props) {
  const {
    className,
    id,
    label
  } = props;
  return /*#__PURE__*/jsx(StyledNotificationIcon$2, {
    className: classnames(infoNotificationIconClassName, className),
    id: id,
    children: /*#__PURE__*/jsx(InfoIcon, {
      label: label
    })
  });
}
InfoNotificationIcon.displayName = 'InfoNotificationIcon';

let _$1 = t => t,
  _t$1;
const successNotificationIconClassName = 'bui-success-notification-icon';

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledNotificationIcon$1 = /*#__PURE__*/styled(NotificationIcon).withConfig({
  displayName: "StyledNotificationIcon",
  componentId: "sc-kcu8d4-0"
})(_t$1 || (_t$1 = _$1`
  color: ${0};
`), colorPositiveIcon);

/**
 * A component that displays a success notification icon.
 * The component also offers an optional invisible label for screen readers.
 *
 * @param props - The component props
 * @public
 *
 * @example
 * ```javascript
 * import * as React from 'react'
 * import { SuccessNotificationIcon } from '@thisisbud/bui-react-notification-icons'
 *
 * function Example() {
 *   return <SuccessNotificationIcon label='Success'/>
 * }
 * ```
 */
function SuccessNotificationIcon(props) {
  const {
    className,
    id,
    label
  } = props;
  return /*#__PURE__*/jsx(StyledNotificationIcon$1, {
    className: classnames(successNotificationIconClassName, className),
    id: id,
    children: /*#__PURE__*/jsx(SuccessIcon, {
      label: label
    })
  });
}
SuccessNotificationIcon.displayName = 'SuccessNotificationIcon';

let _ = t => t,
  _t;
const warningNotificationIconClassName = 'bui-warning-notification-icon';

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledNotificationIcon = /*#__PURE__*/styled(NotificationIcon).withConfig({
  displayName: "StyledNotificationIcon",
  componentId: "sc-1gbifo6-0"
})(_t || (_t = _`
  color: ${0};
`), colorWarningIcon);

/**
 * A component that displays a warning notification icon.
 * The component also offers an optional invisible label for screen readers.
 *
 * @param props - The component props
 * @public
 *
 * @example
 * ```javascript
 * import * as React from 'react'
 * import { WarningNotificationIcon } from '@thisisbud/bui-react-notification-icons'
 *
 * function Example() {
 *   return <WarningNotificationIcon label='Warning'/>
 * }
 * ```
 */
function WarningNotificationIcon(props) {
  const {
    className,
    id,
    label
  } = props;
  return /*#__PURE__*/jsx(StyledNotificationIcon, {
    className: classnames(warningNotificationIconClassName, className),
    id: id,
    children: /*#__PURE__*/jsx(WarningIcon, {
      label: label
    })
  });
}
WarningNotificationIcon.displayName = 'WarningNotificationIcon';

export { CalloutNotificationIcon, ErrorNotificationIcon, InfoNotificationIcon, SuccessNotificationIcon, WarningNotificationIcon, calloutNotificationIconClassName, errorNotificationIconClassName, infoNotificationIconClassName, notificationIconClassName, successNotificationIconClassName, warningNotificationIconClassName };
